import { createApp, provide } from "vue";
import GoodBad from "./components/GoodBad.vue";
import store from "./stores/goodbad.js";

const mounts = document.querySelectorAll(".goodbad");
const apps = [];

[].forEach.call(mounts, (mount, index) => {
    if ("object" === typeof mount) {
        apps[index] = createApp({
            el: ".goodbad",
            components: {
                goodbad: GoodBad,
            },
        });
        apps[index].provide("store", store);
        apps[index].mount(mount);
    } else {
        console.error("Could not render Rita on the expected mount.");
    }
});
